import { useMemo } from "react";
import { useAccount as useMsalAccount } from "@azure/msal-react";
import { formatAccount } from "../auth";

export function useAccount() {
  const account = useMsalAccount();

  return useMemo(() => formatAccount(account), [account]);
}
